module.exports = __webpack_public_path__ + "media/images/country_flags/sm-3f6d84cbbb64b6237e18b81521a4aca8.png";